const ENCODED_TEXT_MARKER = "__optimgovTextHex"

type EncodedText = {
	[ENCODED_TEXT_MARKER]: true
	value: string
}

function textToHex(value: string): string {
	const bytes = new TextEncoder().encode(value)
	return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")
}

/**
 * Encodes arbitrary user/document text for JSON payloads that cross App Gateway
 * WAF. Procurement text commonly contains hashtags, formulas, URLs and legal
 * punctuation that CRS rules can misclassify as SQLi/RFI.
 */
export function encodeTextForWafSafeTransport<T>(value: T): T {
	if (typeof value === "string") {
		return { [ENCODED_TEXT_MARKER]: true, value: textToHex(value) } as T
	}

	if (Array.isArray(value)) {
		return value.map((item) => encodeTextForWafSafeTransport(item)) as T
	}

	if (value && typeof value === "object") {
		return Object.fromEntries(
			Object.entries(value).map(([key, item]) => [key, encodeTextForWafSafeTransport(item)])
		) as T
	}

	return value
}

export type { EncodedText }
